import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefund = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 5V15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4999 7.5C13.4999 7.5 12.3563 6.5 10.9999 6.5C9.6436 6.5 7.99994 7 7.99994 8.5C7.99994 10 10.9999 10 10.9999 10C10.9999 10 13.9999 9.91068 13.9999 11.5C13.9999 13.0893 12.4999 13.5 10.9999 13.5C9.49994 13.5 8.49994 13 8.49994 13",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.73431 7.34814H1.98431V3.59814",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.16635 15.8336C6.32014 16.9874 7.79015 17.7732 9.39049 18.0915C10.9908 18.4098 12.6496 18.2464 14.1571 17.622C15.6646 16.9976 16.9531 15.9402 17.8596 14.5835C18.7661 13.2268 19.25 11.6317 19.25 10C19.25 8.36831 18.7661 6.77325 17.8596 5.41655C16.9531 4.05984 15.6646 3.00242 14.1571 2.378C12.6496 1.75357 10.9908 1.5902 9.39049 1.90853C7.79015 2.22685 6.32014 3.01259 5.16635 4.16637L1.98438 7.34835",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRefund;
